<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chp" id="_idParaDest-6"><a id="_idTextAnchor005"></a></h1>
<p class="Normal"><img alt="" class="_idGenObjectAttribute-1" src="image/HHMap2016Altered4.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Headhunter-6.vue?74506ab0